import { render, staticRenderFns } from "./TransferExternalContent.vue?vue&type=template&id=cb6036b2&lang=pug"
import script from "./TransferExternalContent.vue?vue&type=script&lang=js"
export * from "./TransferExternalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports